import DivisionPage from "./DivisionPage";

export default function LiquidTransport() {
  return <DivisionPage slug="liquid-transport" />;
}
